import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import {
  downloadReportPdf,
  type ReportDateRangeParameters,
} from '@/api/reports/reportsApi';
import { saveDownloadedFile, type DownloadedFile } from '@/api/fileDownload';

export function useDownloadReportPdf(): UseMutationResult<
  DownloadedFile,
  Error,
  ReportDateRangeParameters
> {
  return useMutation({
    mutationFn: function requestReportPdf(dateRange: ReportDateRangeParameters) {
      return downloadReportPdf(dateRange);
    },
    onSuccess: saveDownloadedFile,
  });
}
